import { ICropMediaDetail, IUserCropPreference } from '../../store/interface';
import { useCropPreferenceStore } from '../../store/useCropPreferenceStore';
import { useProfileStore } from '../../store/useProfileStore';
import { ICategory, ICropByCategory, IPreferenceType } from '../kisaan/interface';
import paths from '../paths';
import { WorkflowClient } from './axiosWorkflowClient';
import { ICropPreferenceUpdateResult, IUserCropPreferencePayload } from './interface';

export const createUserPreferenceApi = async (
  config: IUserCropPreferencePayload
): Promise<ICropPreferenceUpdateResult | undefined> => {
  if (!config?.realmId || !config?.userId) {
    return;
  }
  try {
    const response = await WorkflowClient.patch<ICropPreferenceUpdateResult>(
      paths.createUserPreference(config?.realmId, config?.userId),
      config?.formData
    );
    return response?.data ?? undefined;
  } catch (e) {
    console.error('Error creaingt crop preference api', e);
  }
};

export const updateUserPreferenceApi = async (
  config: IUserCropPreferencePayload
): Promise<ICropPreferenceUpdateResult | undefined> => {
  if (!config?.realmId || !config?.userId) {
    return;
  }
  try {
    const response = await WorkflowClient.patch<ICropPreferenceUpdateResult>(
      paths.updateUserPreference(config?.realmId, config?.userId),
      config?.formData
    );
    return response?.data ?? undefined;
  } catch (e) {
    console.error('Error updating crop preference', e);
    return undefined;
  }
};

export const fetchUserCropPreferenceApi = async (
  config: IUserCropPreferencePayload
): Promise<IUserCropPreference | undefined> => {
  if (!config?.realmId || !config?.userId) {
    return;
  }
  try {
    const response = await WorkflowClient.get<IUserCropPreference>(
      paths.getCropsPreference(config?.userId, config?.realmId)
    );
    return response?.data ?? undefined;
  } catch (e) {
    console.error('Error fetching crop preference', e);
    return undefined;
  }
};

export const fetchCropMediaDetailApi = async (cropId: string[]): Promise<ICropByCategory[]> => {
  try {
    const response = await WorkflowClient.get<ICropByCategory[]>(paths.getCropMediaDetail(), {
      params: {
        cropId: cropId,
      },
      paramsSerializer: {
        indexes: true, // use brackets with indexes
      },
    });
    return response?.data ?? [];
  } catch (e) {
    console.error('Error fetching crop media detail', e);
    return [];
  }
};

export const getUserPreferenceDetail = async (type: IPreferenceType) => {
  if (
    useProfileStore.getState()?.userProfile?.realm?.id &&
    useProfileStore.getState()?.userProfile?.user?.id
  ) {
    try {
      const config: IUserCropPreferencePayload = {
        realmId: useProfileStore.getState()?.userProfile?.realm.id ?? '-1',
        userId: useProfileStore.getState()?.userProfile?.user.id ?? '-1',
      };
      const response = await fetchUserCropPreferenceApi(config);

      if (response?.data) {
        useCropPreferenceStore.getState()?.setUserPreferenceId(response?.data?.id);

        if (type === IPreferenceType.CROP && response?.data?.cropPreferences?.length > 0) {
          useCropPreferenceStore.getState()?.setCropPreference(response?.data?.cropPreferences);
        }

        if (type === IPreferenceType.ANIMAL && response?.data?.animalPreference?.length > 0) {
          useCropPreferenceStore.getState()?.setAnimalPreference(response?.data?.animalPreference);
        }
        return response;
      }
    } catch (error) {
      console.error(`Error fetching ${type} preference`, error);
    }
  }
};
